import {
  FaSquareFacebook,
  FaSquareInstagram,
  FaSquareXTwitter,
} from "react-icons/fa6";
import { AiFillTikTok } from "react-icons/ai";
import "../assets/css/socialMedia.css";

export const SocialMediaTypeList = [
  {
    value: "facebook",
    label: (
      <span>
        <FaSquareFacebook className="social-media-icon-bo" />
        <label>Facebook</label>
      </span>
    ),
  },
  {
    value: "tiktok",
    label: (
      <span>
        <AiFillTikTok className="social-media-icon-bo" />
        <label>TikTok</label>
      </span>
    ),
  },
  {
    value: "instagram",
    label: (
      <span>
        <FaSquareInstagram className="social-media-icon-bo" />
        <label>Instagram</label>
      </span>
    ),
  },
  {
    value: "x",
    label: (
      <span>
        <FaSquareXTwitter className="social-media-icon-bo" />
        <label>X</label>
      </span>
    ),
  },
];
